import { Avatar } from '@yembo/yemblocks-core';
import { UserRole } from 'src/types';
import { USER_ROLE_LABELS } from '../_util/constants';

type AvatarSectionProps = {
  userName: string;
  photoUrl: string;
  role: UserRole;
  isCollapsed?: boolean;
  avatarSize?: 'small' | 'medium';
};

export const AvatarSection = ({ userName, photoUrl, role, isCollapsed, avatarSize = 'medium' }: AvatarSectionProps) => {
  return (
    <div className={`avatar-section ${isCollapsed ? 'collapsed' : ''}`}>
      <Avatar size={avatarSize} placeholder={userName[0]} imageUrl={photoUrl} />

      {!isCollapsed && (
        <div className='user-info'>
          <p className='bold'>{userName}</p>
          <p className='user-role tiny-text'>{USER_ROLE_LABELS[role]}</p>
        </div>
      )}
    </div>
  );
};
